import React from "react";

// SectionTitle: overline + serif heading + optional kicker
export default function SectionTitle({ overline, title, kicker, align = "left", invert = false }) {
  const center = align === "center";
  const color = invert ? "text-white" : "text-black";
  const muted = invert ? "text-white/60" : "text-neutral-600";

  return (
    <div className={`${center ? "text-center mx-auto" : ""} max-w-3xl ${center ? "" : ""}`}>
      {overline && (
        <p className={`overline ${invert ? "text-white/60" : ""}`}>{overline}</p>
      )}
      <h2 className={`font-serif-display ${color} text-3xl sm:text-4xl lg:text-5xl mt-3 tracking-tight leading-[1.05]`}>
        {title}
      </h2>
      {kicker && (
        <p className={`mt-5 ${muted} text-base lg:text-lg leading-relaxed`}>{kicker}</p>
      )}
    </div>
  );
}
